import { QueueItem } from '../../coaching-tags/models/queue.coaching.model';
import { User } from '../../user/user.model';
import { Draft, Form, Response } from '../core';
import { DisplayControls } from '../core/model/form/display-controls.model';

export interface FormState {
    pending: {
        reload?: boolean;
        save?: boolean;
        publish?: boolean;
        showPublishConfirmDialog?: boolean;
    };

    targetUser?: User;
    draft?: Draft;
    response?: Response;
    form?: Form;

    canEditResponse?: boolean;
    displayControls?: DisplayControls;
    queues?: QueueItem[];
}

export const defaultState = (): FormState => ({
    pending: {},
});
